module.exports = __webpack_public_path__ + "static/media/m11.cffbf44a.jpg";